module.exports = __webpack_public_path__ + "static/media/BookmarkIcon.ae98201a.svg";